// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__nBpd3","buttons":"RemoveExpirationActionButtons_buttons__3PDBX"};